import { render } from "./NavbarAdminComponent.vue?vue&type=template&id=0864e208&scoped=true"
import script from "./NavbarAdminComponent.vue?vue&type=script&lang=js"
export * from "./NavbarAdminComponent.vue?vue&type=script&lang=js"

import "./NavbarAdminComponent.vue?vue&type=style&index=0&id=0864e208&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0864e208"]])

export default __exports__